<template>
  <div class="formCon">
    <a-config-provider :locale="locale">
      <div ref="formContainer" class="pagePop formC" :class="{ 'is-fullscreen': isFullscreen }">
        <div class="w pad60">
          <!-- 标题栏 -->
          <div class="tit fnt_24">
            <span>{{ globalDataArray.siteTemplateLanguage.create_competition || '我要办赛' }}</span>
            <div class="tit-icons">
              <a-icon
                :type="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
                class="icon-btn fullscreen-icon"
                @click="toggleFullscreen"
              />
              <a-icon
                type="close"
                class="icon-btn close-icon"
                @click="handleCancel"
              />
            </div>
          </div>

          <div class="cont">
            <div class="stform">
              <a-steps :current="currentStep" style="margin-bottom: 24px">
                <a-step :title="globalDataArray.siteTemplateLanguage.basic_info || '基本信息'" />
                <a-step :title="globalDataArray.siteTemplateLanguage.competition_info || '赛事信息'" />
                <a-step :title="globalDataArray.siteTemplateLanguage.progress_schedule || '进度安排'" />
              </a-steps>

              <!-- Step 1: Basic Info -->
              <div v-show="currentStep === 0">
                <a-form ref="basicFormRef" layout="vertical" class="stform">
                  <!--用奖金设置和共建方 >> 姓名和密码-->
                  <div class="item">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.name_text || '姓名'" :required="true">
                        <a-input
                          v-model="formData.name"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名'"
                          @blur="validateName"
                        />
                      </a-form-item>
                      <div v-if="nameError" class="error-message">{{ nameError }}</div>
                    </div>

                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.phone_setting || '联系方式'" :required="true">
                        <a-input
                          v-model="formData.phone"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_phone || '请输入联系方式'"
                          @blur="validatePhone"
                          @input="(e) => handlePhoneInput(e)"
                        />
                        <!--                        -->
                      </a-form-item>
                      <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
                    </div>
                  </div>

                  <!--用赛事名称 >> 单位名称-->
                  <div class="item single-field">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.unit_name || '单位名称'" :required="true">
                        <a-input
                          v-model="formData.unitName"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_unit_name || '请输入单位名称'"
                          @blur="validateUnitName"
                        />
                      </a-form-item>
                      <div v-if="unitNameError" class="error-message">{{ unitNameError }}</div>
                    </div>
                  </div>

                  <!--赛事名称-->
                  <div class="item single-field">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.competition_name || '赛事名称'" :required="true">
                        <a-input
                          v-model="formData.title"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_competition_name || '请输入赛事名称'"
                          @blur="(e) => handleTitleBlur(formData.title)"
                        />
                      </a-form-item>
                      <div v-if="titleError" class="error-message">{{ titleError }}</div>
                    </div>
                  </div>
                  <!-- 英文名称 -->
                  <div class="item single-field">
                    <div class="form-field">
                      <a-form-item label="赛事英文名称" :required="true">
                        <a-input
                          v-model="formData.titleEn"
                          placeholder="请输入赛事英文名称"
                          @blur="validateTitleEn"
                        />
                      </a-form-item>
                      <div v-if="titleEnError" class="error-message">{{ titleEnError }}</div>
                    </div>
                  </div>
                  <!-- 共建单位证书名称 -->
                  <div class="item single-field">
                    <div class="form-field">
                      <a-form-item label="共建单位证书名称" :required="true">
                        <div style="color: #888; font-size: 12px; margin-bottom: 4px;">示例：开放原子开源基金会，OpenAtom Foundation</div>
                        <div v-for="(unit, idx) in formData.coBuildUnitNames" :key="unit.id" class="co-build-unit-group">
                          <a-input v-model="unit.name_zh" placeholder="如：开放原子开源基金会" style="margin-right: 8px; width: 40%;" />
                          <a-input v-model="unit.name_en" placeholder="如：OpenAtom Foundation" style="margin-right: 8px; width: 40%;" />
                          <a-button @click="removeCoBuildUnitName(idx)" icon="delete" />
                        </div>
                        <a-button @click="addCoBuildUnitName" icon="plus">添加共建单位中英文名称</a-button>
                      </a-form-item>
                      <div v-if="coBuildUnitNamesError" class="error-message">{{ coBuildUnitNamesError }}</div>
                    </div>
                  </div>

                  <!--技术方向-->
                  <div class="item">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.technical_direction || '技术方向'">
                        <a-select
                          v-model="formData.technicalId"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_select_technical_direction || '请选择技术方向'"
                          :get-popup-container="triggerNode => getParentContainer(triggerNode)"
                          allow-clear
                        >
                          <a-select-option
                            v-for="tech in technicalList"
                            :key="tech.parentId"
                            :value="tech.parentId"
                          >
                            {{ tech.title }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </div>

                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.parent_competition || '父赛项'">
                        <a-select
                          v-model="formData.parentCompetitionId"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_select_parent_competition || '请选择父赛项'"
                          :options="parentCompetitionList.map(item => ({
                            value: item.id,
                            label: item.title
                          }))"
                          :get-popup-container="triggerNode => getParentContainer(triggerNode)"
                          allow-clear
                        />
                      </a-form-item>
                    </div>
                  </div>

                  <!--团队人数-->
                  <div class="item">
                    <!--新的-->
                    <div class="form-field">
                      <a-form-item
                        :label="globalDataArray.siteTemplateLanguage.team_size || '团队人数'"
                        :required="true"
                      >
                        <a-input
                          v-model="formData.teamsUsers"
                          type="number"
                          :min="0"
                          style="width: 100%"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_team_size || '请输入团队人数'"
                          @input="handleTeamSizeInput"
                          @blur="validateTeamSize"
                        />
                      </a-form-item>
                      <div v-if="teamSizeError" class="error-message">{{ teamSizeError }}</div>
                    </div>

                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.category_select || '赛事类别'" :required="true">
                        <a-select
                          v-model="formData.categoryId"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_select_category || '请选择赛事类别'"
                          :get-popup-container="triggerNode => getParentContainer(triggerNode)"
                          @blur="validateCategoryId"
                          allow-clear
                        >
                          <a-select-option
                            v-for="category in categoryList"
                            :key="category.id"
                            :value="category.parentId"
                          >
                            {{ category.title }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                      <div v-if="categoryIdError" class="error-message">{{ categoryIdError }}</div>
                    </div>
                  </div>

                  <!--标签-->
                  <div class="item single-field">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.tags || '标签'">
                        <a-input
                          v-model="formData.mark"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_tags || '请输入标签，例如：算力支持,开发版'"
                        />
                      </a-form-item>
                    </div>
                  </div>

                  <!--报名时间-->
                  <div class="item">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.start_time || '报名开始时间'" :required="true">
                        <a-date-picker
                          v-model="formData.startTime"
                          show-time
                          format="YYYY-MM-DD HH:mm:ss"
                          style="width: 100%"
                          :get-calendar-container="triggerNode => getParentContainer(triggerNode)"
                          @change="(date) => handleStartTimeChange(date, formData)"
                        />
                        <!--                        @blur="validateTimeRange"-->
                      </a-form-item>
                      <div v-if="startTimeError" class="error-message">{{ startTimeError }}</div>
                    </div>

                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.end_time || '报名结束时间'" :required="true">
                        <a-date-picker
                          v-model="formData.endTime"
                          show-time
                          format="YYYY-MM-DD HH:mm:ss"
                          style="width: 100%"
                          :get-calendar-container="triggerNode => getParentContainer(triggerNode)"
                          @change="(date) => handleEndTimeChange(date, formData)"
                        />
                      </a-form-item>
                      <div v-if="endTimeError" class="error-message">{{ endTimeError }}</div>
                    </div>
                  </div>

                  <!--奖金和共建方-->
                  <div class="item">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.competition_bonus || '奖金设置'" :required="true">
                        <a-input
                          v-model="formData.bonus"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_bonus || '请输入奖金设置'"
                          @blur="validateBonus"
                        />
                      </a-form-item>
                      <div v-if="bonusError" class="error-message">{{ bonusError }}</div>
                    </div>

                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.competition_co_builder || '共建方'" :required="true">
                        <a-input
                          v-model="formData.organizers"
                          :placeholder="globalDataArray.siteTemplateLanguage.please_enter_organizers || '请输入共建方'"
                          @blur="validateOrganizers"
                        />
                      </a-form-item>
                      <div v-if="organizersError" class="error-message">{{ organizersError }}</div>
                    </div>
                  </div>

                  <!--在这开始改-->
                  <div class="item full-width">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.organizers_logo || '共建方Logo'" prop="organizersLogo" class="logo-upload-container">
                        <a-upload
                          multiple
                          accept="image/*"
                          :file-list="formData.logoFileList || []"
                          :before-upload="beforeLogoUpload"
                          :custom-request="uploadLogo"
                          :remove="handleLogoRemove"
                          @change="handleLogoChange"
                          @preview="handleLogoPreview"
                          :show-upload-list="{
                            showPreviewIcon: true,
                            showRemoveIcon: true,
                            showDownloadIcon: false
                          }"
                          list-type="picture-card"
                        >
                          <div v-if="getLogoFileCount() < 4">
                            <a-icon type="plus" />
                            <div class="ant-upload-text">{{ globalDataArray.siteTemplateLanguage.upload_logo || '上传Logo' }}</div>
                          </div>
                        </a-upload>
                        <span class="text-tip">{{ globalDataArray.siteTemplateLanguage.image_size_logo || '图片宽度*高度至少为200*200像素，大小不超过2MB，最多上传4张' }}</span>
                      </a-form-item>
                    </div>
                  </div>

                  <div class="item full-width">
                    <div class="form-field">
                      <a-form-item :label="globalDataArray.siteTemplateLanguage.cover_image || '封面图'" prop="image" class="logo-upload-container" :required="true">
                        <a-upload
                          accept="image/*"
                          :file-list="formData.imageFileList || []"
                          :before-upload="beforeImageUpload"
                          :custom-request="uploadImage"
                          :remove="handleImageRemove"
                          @change="handleImageChange"
                          @preview="handleImagePreview"
                          :show-upload-list="{
                            showPreviewIcon: true,
                            showRemoveIcon: true,
                            showDownloadIcon: false
                          }"
                          list-type="picture-card"
                          @blur="validateCoverImage"
                        >
                          <div v-if="getImageFileCount() < 1">
                            <a-icon type="plus" />
                            <div class="ant-upload-text">{{ globalDataArray.siteTemplateLanguage.upload_cover || '上传封面图' }}</div>
                          </div>
                        </a-upload>
                        <span class="text-tip">{{ globalDataArray.siteTemplateLanguage.image_size || '图片宽度*高度至少为200*200像素，大小不超过2MB' }}</span>
                      </a-form-item>
                      <div v-if="coverImageError" class="error-message">{{ coverImageError }}</div>
                    </div>
                  </div>

                  <div class="line"></div>
                </a-form>
              </div>

              <!-- Step 2: Competition Info -->
              <div v-show="currentStep === 1" class="stform">
                <a-form ref="infoFormRef" layout="vertical" class="stform">
                  <div class="info-form">
                    <template v-for="(info, infoIndex) in formData.info">
                      <div :key="infoIndex" class="info-item">
                        <div class="item info-header">
                          <a-form-item :label="globalDataArray.siteTemplateLanguage.title || '标题'">
                            <a-input
                              v-model="info.title"
                              :placeholder="globalDataArray.siteTemplateLanguage.please_enter_title || '请输入标题'"
                            />
                          </a-form-item>
                          <a-button type="link" @click="removeInfo(infoIndex)" danger style="flex-shrink: 0;">
                            {{ globalDataArray.siteTemplateLanguage.delete || '删除' }}
                          </a-button>
                        </div>
                        <div v-if="info.images" class="item image-preview">
                          <img :src="info.images"></img>
                          <a-button type="link" @click="removeInfoImage(infoIndex)" danger>
                            <a-icon type="delete" />
                          </a-button>
                        </div>
                        <div class="item">
                          <markdown-editor
                            v-model="info.content"
                            height="600px"
                            @change="handleEditorChange($event, infoIndex)"
                          />
                        </div>
                      </div>
                      <div class="line" :key="infoIndex" v-if="infoIndex !== formData.info.length - 1"></div>
                    </template>
                    <a-button type="dashed" style="width: 100%; margin-bottom: 16px" @click="addInfo">
                      + {{ globalDataArray.siteTemplateLanguage.add_competition_info || '添加赛事信息' }}
                    </a-button>
                  </div>
                </a-form>
              </div>

              <!-- Step 3: Progress -->
              <div v-show="currentStep === 2" class="stform">
                <a-form ref="progressFormRef" layout="vertical" class="stform">
                  <div class="progress-form">
                    <template v-for="(progress, progressIndex) in formData.progress">
                      <div :key="progressIndex" class="item">
                        <div class="form-field">
                          <a-form-item :label="globalDataArray.siteTemplateLanguage.node_name || '节点名称'" :required="true">
                            <a-input
                              v-model="progress.title"
                              :placeholder="globalDataArray.siteTemplateLanguage.please_enter_node_title || '请输入节点标题'"
                              @blur="validateNodeTitle(progressIndex)"
                              @input="handleNodeTitleInput(progressIndex)"
                            />
                          </a-form-item>
                          <div v-if="progress.titleNodeError" class="error-message">{{ progress.titleNodeError }}</div>
                        </div>

                        <div class="form-field">
                          <a-form-item :label="globalDataArray.siteTemplateLanguage.node_time || '节点时间'" :required="true">
                            <a-date-picker
                              v-model="progress.startDate"
                              format="YYYY-MM-DD"
                              style="width: 100%"
                              :placeholder="globalDataArray.siteTemplateLanguage.node_time || '节点时间'"
                              :get-calendar-container="triggerNode => getParentContainer(triggerNode)"
                              @change="(date) => { handleProgressDateChange(date, progressIndex); validateNodeTime(progressIndex); }"
                            />
                          </a-form-item>
                          <div v-if="progress.startDateError" class="error-message">{{ progress.startDateError }}</div>
                        </div>

                        <a-button type="link" @click="removeProgress(progressIndex)" danger style="flex-shrink: 0; align-self: flex-start;">
                          {{ globalDataArray.siteTemplateLanguage.delete || '删除' }}
                        </a-button>
                      </div>
                    </template>
                    <a-button type="dashed" style="width: 100%; margin-bottom: 16px" @click="addProgress">
                      + {{ globalDataArray.siteTemplateLanguage.add_progress_node || '添加进度节点' }}
                    </a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </div>

          <div class="btnBox fnt_18">
            <div
              v-if="currentStep > 0"
              class="btn btn1"
              @click="prevStep"
              :disabled="loading"
            >
              {{ globalDataArray.siteTemplateLanguage.previous || '上一步' }}
            </div>
            <div
              v-if="currentStep < 2"
              class="btn btn1"
              @click="nextStep"
              :disabled="loading"
            >
              {{ globalDataArray.siteTemplateLanguage.next || '下一步' }}
            </div>
            <div
              v-if="currentStep === 2"
              class="btn btn1"
              :class="{ 'loading': loading, 'disabled': loading }"
              @click="!loading && handleSubmit()"
              :disabled="loading"
            >
              <a-icon v-if="loading" type="loading" style="margin-right: 8px;" />
              {{ globalDataArray.siteTemplateLanguage.submit_application || '提交申请' }}
            </div>
            <div
              class="btn btn2"
              @click="handleCancel"
              :disabled="loading"
            >
              {{ globalDataArray.siteTemplateLanguage.cancel || '取消' }}
            </div>

            <!-- 图片预览模态框 -->
            <a-modal
              v-model="previewVisible"
              title="图片预览"
              footer=""
              @cancel="previewVisible = false"
              :width="600"
            >
              <img :src="previewImageUrl" alt="预览图" style="width: 100%">
            </a-modal>
          </div>
        </div>
      </div>
    </a-config-provider>
  </div>
</template>

<script>
import moment from 'moment'
import { getZoneList } from '@/api/zone'
import { getCategoryList, getTechnicalList } from '@/api/saiti'
import { getCompetitionDict } from '@/api/api'
import { getParentCompetition, uploadMultiFile, uploadFile, verifyTitle } from '@/api/more/more'
import Cookies from 'js-cookie'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import jaJP from 'ant-design-vue/lib/locale-provider/ja_JP'
import koKR from 'ant-design-vue/lib/locale-provider/ko_KR'
import frFR from 'ant-design-vue/lib/locale-provider/fr_FR'
import deDE from 'ant-design-vue/lib/locale-provider/de_DE'
import esES from 'ant-design-vue/lib/locale-provider/es_ES'
import ruRU from 'ant-design-vue/lib/locale-provider/ru_RU'
import ptBR from 'ant-design-vue/lib/locale-provider/pt_BR'
import itIT from 'ant-design-vue/lib/locale-provider/it_IT'

export default {
  name: 'CreateCompetition',
  components: {
    MarkdownEditor: () => import ('@/components/MarkdownEditor')
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      currentStep: 0,
      formData: {},
      zoneList: [],
      categoryList: [],
      technicalList: [],
      parentCompetitionList: [],
      typeList: [],
      formRules: {
        title: [{ required: true, message: '请输入赛事名称' }]
      },
      saitiAccessInfo: {},
      isFullscreen: false,
      locale: zhCN,
      previewVisible: false,
      previewImageUrl: '',
      titleError: '', // 用于存储错误提示信息
      nameError: '',
      phoneError: '',
      unitNameError: '',
      teamSizeError: '',
      categoryIdError: '',
      startTimeError: '',
      endTimeError: '',
      bonusError: '',
      organizersError: '',
      coverImageError: '',
      nodeTimeError: '',
      hasUserModifications: false, // 标记用户是否进行了修改操作
      titleValidateTimer: null, // 标题验证防抖定时器,
      titleNodeError: '',
      titleEnError: '',
      coBuildUnitNamesError: ''
    }
  },
  created() {
    console.log('CreateCompetition组件初始化')
    this.initUserInfo()
    this.initFormData()
    this.fetchLists()

    // 确保表单数据使用当前系统语言
    const currentLanguage = this.getCurrentLanguage()
    console.log('初始化时的系统语言:', currentLanguage)

    if (this.formData.language !== currentLanguage) {
      this.formData.language = currentLanguage
    }

    // 更新locale设置
    this.updateLocale()
    console.log('初始化完成，当前locale:', this.locale.locale)
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
  },
  watch: {
    visible: {
      handler(newVal) {
        // 当对话框关闭时重置loading状态
        if (!newVal) {
          this.loading = false
        }
      }
    },
    editData: {
      handler(val) {
        if (val && !this.hasUserModifications) {
          this.setEditData(val)
          this.hasUserModifications = false // 重置标记
        }
      },
      immediate: true
    },
    // 监听全局语言变化
    'globalDataArray.currentLanguage': {
      handler(newLanguage) {
        if (newLanguage) {
          console.log('系统语言变化:', newLanguage)
          this.updateLocaleForSystemLanguage(newLanguage)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取弹出容器，让日期选择器在合适的容器内显示
    getParentContainer(triggerNode) {
      // 查找最近的滚动容器
      let container = triggerNode.parentNode

      // 向上查找合适的容器
      while (container && container !== document.body) {
        const computedStyle = window.getComputedStyle(container)
        const overflow = computedStyle.overflow || computedStyle.overflowY

        // 优先找到内容滚动容器(.cont)
        if (container.classList.contains('cont')) {
          return container
        }

        // 或者找到设置了滚动的容器
        if (overflow === 'auto' || overflow === 'scroll') {
          return container
        }

        // 如果找到表单容器也可以使用
        if (container.classList.contains('formC') ||
            container.classList.contains('stform')) {
          return container
        }

        container = container.parentNode
      }

      // 如果都没找到，返回触发节点的父容器
      return triggerNode.parentNode
    },

    // 姓名
    validateName() {
      const value = this.formData.name
      if (!value || value.trim() === '') {
        this.nameError = this.globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名'
        return false
      } else {
        this.nameError = ''
        return true
      }
    },
    // 手机号码11之后的截断
    handlePhoneInput(e) {
      let value = e.target.value
      const currentLang = this.getCurrentLanguage()
      const isChineseMode = ['zh_CN', 'zh-CN', 'zh'].includes(currentLang)

      if (isChineseMode) {
        value = value.replace(/[^0-9]/g, '')
        if (value.length > 11) {
          value = value.slice(0, 11)
          this.$nextTick(() => {
            e.target.value = value // 同步输入框显示
          })
        }
      }

      this.formData.phone = value
      this.validatePhone
    },
    // 手机号验证
    validatePhone() {
      const phone = this.formData.phone.trim() // 获取最新输入值
      const currentLang = this.getCurrentLanguage()
      const isChineseMode = ['zh_CN', 'zh-CN', 'zh'].includes(currentLang)

      // 必填验证（所有语言都需要）
      if (!phone) {
        this.phoneError = this.globalDataArray.siteTemplateLanguage.please_enter_phone || '请输入联系方式'
        return false
      }

      // 仅在中文模式下做详细格式校验
      if (isChineseMode) {
        // 限制输入长度为11位
        if (phone.length !== 11) {
          this.phoneError = '请输入有效的11位手机号码'
          return false
        }

        const isValidPhone = /^1[3-9]\d{9}$/.test(phone)
        if (!isValidPhone) {
          this.phoneError = '请输入有效的11位手机号码'
          return false
        }
      } else {
        this.phoneError = ''
        return true
      }

      this.phoneError = ''
      return true
    },
    // 单位名称
    validateUnitName() {
      const value = this.formData.unitName
      if (!value || value.trim() === '') {
        this.unitNameError = this.globalDataArray.siteTemplateLanguage.please_enter_unit_name || '请输入单位名称'
        return false
      } else {
        this.unitNameError = ''
        return true
      }
    },
    // 团队人数
    validateTeamSize() {
      const value = this.formData.teamsUsers
      if (!value || value <= 0) {
        this.teamSizeError = this.globalDataArray.siteTemplateLanguage.please_set_team_size || '请设置团队人数'
        return false
      } else {
        this.teamSizeError = ''
        return true
      }
    },
    // 赛事类别
    validateCategoryId() {
      const value = this.formData.categoryId
      if (!value) {
        this.categoryIdError = this.globalDataArray.siteTemplateLanguage.please_select_category || '请选择赛事类别'
        return false
      } else {
        this.categoryIdError = ''
        return true
      }
    },
    // 报名时间
    validateTimeRange() {
      const start = this.formData.startTime
      const end = this.formData.endTime

      // 重置错误信息
      this.startTimeError = ''
      this.endTimeError = ''

      // 只在失焦时验证
      if (!start) {
        this.startTimeError = this.globalDataArray.siteTemplateLanguage.please_set_start_time || '请设置开始时间'
      }

      if (!end) {
        this.endTimeError = this.globalDataArray.siteTemplateLanguage.please_set_end_time || '请设置结束时间'
      }

      // 如果两个时间都有值，再验证顺序
      if (start && end) {
        if (moment(end).isSameOrBefore(start)) {
          this.endTimeError = '结束时间必须晚于开始时间'
          return false
        }
      }

      return !(this.startTimeError || this.endTimeError)
    },
    // 节点时间
    validateNodeTimeRange() {
      // 检查是否有节点时间为空
      let hasEmptyNodeTime = false
      if (this.formData.progress && this.formData.progress.length > 0) {
        hasEmptyNodeTime = this.formData.progress.some(progress => !progress.startDate)
      }

      if (hasEmptyNodeTime) {
        this.nodeTimeError = this.globalDataArray.siteTemplateLanguage.please_set_node_time || '请设置节点时间'
        return false
      } else {
        this.nodeTimeError = ''
        return true
      }
    },
    // 验证单个节点时间
    validateSingleNodeTime(index) {
      if (this.formData.progress && this.formData.progress[index]) {
        const progress = this.formData.progress[index]
        if (!progress.startDate) {
          this.nodeTimeError = this.globalDataArray.siteTemplateLanguage.please_set_node_time || '请设置节点时间'
          return false
        } else {
          // 只有当前节点有时间时才清除错误（可能其他节点还没有时间）
          if (this.formData.progress.every(p => p.startDate)) {
            this.nodeTimeError = ''
          }
          return true
        }
      }
      return false
    },
    // 奖金设置验证
    validateBonus() {
      const value = this.formData.bonus
      if (!value || value.trim() === '') {
        this.bonusError = this.globalDataArray.siteTemplateLanguage.please_enter_bonus || '请输入奖金（￥）'
        return false
      } else {
        this.bonusError = ''
        return true
      }
    },

    // 共建方验证
    validateOrganizers() {
      const value = this.formData.organizers?.trim()
      if (!value) {
        this.organizersError = this.globalDataArray.siteTemplateLanguage.please_enter_organizers || '请输入共建方'
        return false
      } else if (/[,，]/.test(value)) {
        this.organizersError = '请勿使用逗号分隔'
        return false
      } else {
        this.organizersError = ''
        return true
      }
    },
    // 封面图验证
    validateCoverImage() {
      const hasImage = (this.formData.imageFileList && this.formData.imageFileList.length > 0) || this.formData.image
      if (!hasImage) {
        this.coverImageError = this.globalDataArray.siteTemplateLanguage.please_upload_cover || '请上传封面图'
        return false
      } else {
        this.coverImageError = ''
        return true
      }
    },

    // 团队人数输入验证
    handleTeamSizeInput(e) {
      let value = e.target.value
      // 只允许数字
      value = value.replace(/[^\d]/g, '')
      // 限制最小值为0
      if (parseInt(value) < 0) {
        value = '0'
      }
      this.formData.teamsUsers = value
    },

    // 团队人数
    increaseTeamSize() {
      this.formData.teamsUsers += 1
    },
    decreaseTeamSize() {
      if (this.formData.teamsUsers > 0) {
        this.formData.teamsUsers -= 1
      }
    },
    // 验证所有赛事信息是否有效
    validateCompetitionInfo() {
      if (!this.formData.info || this.formData.info.length === 0) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.please_add_competition_info || '请至少添加一条赛事信息')
        return false
      }

      //   检查每条信息是否包含必要内容
      const isValid = this.formData.info.every(info => {
        //   至少需要标题和内容
        return info.title.trim() && info.content.trim()
      })

      if (!isValid) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.please_complete_info || '请完成所有赛事信息的填写')
        return false
      }

      return true
    },
    // 验证所有进度节点是否填写了必要信息
    validateProgressNodes() {
      if (this.formData.progress.length === 0) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.please_add_progress_node || '请至少添加一个进度节点')
        return false
      }

      let hasError = false

      // 使用forEach而不是every，确保所有节点都被检查
      this.formData.progress.forEach((progress, index) => {
        // 检查节点名称
        if (!progress.title.trim()) {
          this.$set(this.formData.progress[index], 'titleNodeError', this.globalDataArray.siteTemplateLanguage.please_enter_node_title || '请输入节点标题')
          hasError = true
        } else {
          // 清除节点名称错误信息
          this.$set(this.formData.progress[index], 'titleNodeError', '')
        }

        // 检查节点时间
        if (!progress.startDate) {
          this.$set(this.formData.progress[index], 'startDateError', this.globalDataArray.siteTemplateLanguage.please_set_node_time || '请设置节点时间')
          hasError = true
        } else {
          // 清除节点时间错误信息
          this.$set(this.formData.progress[index], 'startDateError', '')
        }
      })

      if (hasError) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.please_complete_node_info || '请完成所有进度节点的填写')
        return false
      }

      return true
    },

    // 获取Logo文件数量
    getLogoFileCount() {
      return this.formData.logoFileList ? this.formData.logoFileList.length : 0
    },

    // 获取封面图文件数量
    getImageFileCount() {
      return this.formData.imageFileList ? this.formData.imageFileList.length : 0
    },

    initUserInfo() {
      if (Cookies.get('saiti_access_info')) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
    },

    async fetchLists() {
      try {
        const zoneRes = await getZoneList('')
        if (zoneRes.success) {
          this.zoneList = zoneRes.result
        }

        const categoryRes = await getCategoryList()
        if (categoryRes.success) {
          this.categoryList = categoryRes.result
        }

        const technicalRes = await getTechnicalList()
        if (technicalRes.success) {
          this.technicalList = technicalRes.result
        }

        const createBy = this.saitiAccessInfo.username || ''
        const parentRes = await getParentCompetition('createBy=' + createBy)
        if (parentRes.success && parentRes.result?.records) {
          this.parentCompetitionList = parentRes.result.records
        }

        const typeRes = await getCompetitionDict('dictCode=competition_type')
        if (typeRes.success && typeRes.result?.length > 0) {
          this.typeList = typeRes.result[0].list || []
        }
      } catch (error) {
        console.error('Error fetching lists:', error)
      }
    },

    initFormData() {
      const currentLanguage = this.getCurrentLanguage()
      this.formData = this.getInitialFormData(currentLanguage)
      // 初始化时重置loading状态
      this.loading = false
    },

    getCurrentLanguage() {
      // 从Cookie或globalDataArray获取当前语言
      const cookieLang = Cookies.get('DEFAULT_LANG')
      if (cookieLang) {
        return cookieLang
      }
      return this.globalDataArray?.currentLanguage || 'zh_CN'
    },

    getInitialFormData(language = null) {
      const lang = language || this.getCurrentLanguage()
      return {
        id: undefined,
        parentId: undefined, // 添加parentId字段
        language: lang,
        title: '',
        bonus: '',
        categoryId: undefined,
        zoneId: undefined,
        technicalId: undefined,
        parentCompetitionId: undefined,
        type: undefined,
        teamsUsers: 1,
        startTime: undefined,
        endTime: undefined,
        mark: '',
        organizers: '',
        organizersLogo: '',
        logoFileList: [],
        image: '',
        imagePath: '',
        imageFileList: [],
        info: [],
        progress: [],
        //   姓名 联系方式 单位名称
        name: '',
        phone: '',
        unitName: ''
      }
    },

    async nextStep() {
      if (this.currentStep === 0) {
        // 检查是否有正在上传的文件
        const hasUploadingLogo = this.formData.logoFileList && this.formData.logoFileList.some(file => file.status === 'uploading')
        const hasUploadingImage = this.formData.imageFileList && this.formData.imageFileList.some(file => file.status === 'uploading')

        if (hasUploadingLogo || hasUploadingImage) {
          this.$message.warning('请等待文件上传完成')
          return
        }

        // 执行所有验证 { target: { value: this.formData.phone }}
        const isNameValid = this.validateName()
        const isPhoneValid = this.validatePhone()
        const isUnitNameValid = this.validateUnitName()
        const isTitleValid = this.validateTitle()
        const isTitleEnValid = this.validateTitleEn()
        const isCoBuildUnitNamesValid = this.validateCoBuildUnitNames()
        const isTeamSizeValid = this.validateTeamSize()
        const isCategoryIdValid = this.validateCategoryId()
        const isTimeRangeValid = this.validateTimeRange()
        const isBonusValid = this.validateBonus()
        const isOrganizersValid = this.validateOrganizers()
        const isCoverImageValid = this.validateCoverImage()

        // 检查是否有错误
        if (!isNameValid || !isPhoneValid || !isUnitNameValid || !isTitleValid ||
            !isTitleEnValid || !isCoBuildUnitNamesValid ||
            !isTeamSizeValid || !isCategoryIdValid || !isTimeRangeValid ||
            !isBonusValid || !isOrganizersValid || !isCoverImageValid) {
          return
        }

        // 验证通过，进入下一步
        this.currentStep++
      } else if (this.currentStep === 1) {
        if (!this.validateCompetitionInfo()) {
          return
        }
        this.currentStep++
      } else if (this.currentStep === 2) {
        if (!this.validateProgressNodes()) {
          return
        }
        this.currentStep++
      } else {
        this.currentStep++
      }
    },

    prevStep() {
      this.currentStep--
    },

    async handleSubmit() {
      // 防止重复提交
      if (this.loading) {
        return
      }

      try {
        // 开始提交，设置loading状态
        this.loading = true

        // 姓名 联系方式  单位名称
        if (!this.formData.name) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_enter_name || '请输入姓名')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.phone) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_enter_phone || '请输入联系方式')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.unitName) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_enter_unit_name || '请输入单位名称')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.title) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_enter_competition_name || '请输入赛事名称')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.categoryId) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_select_category || '请选择赛事类别')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.teamsUsers) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_set_team_size || '请设置团队人数')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.bonus) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_enter_bonus || '请输入奖金（￥）')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.startTime) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_set_start_time || '请设置开始时间')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.endTime) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_set_end_time || '请设置结束时间')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (!this.formData.image && !this.formData.imagePath) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_upload_cover || '请上传封面图')
          this.currentStep = 0
          this.loading = false
          return
        }

        if (this.formData.info.length === 0) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_add_competition_info || '请至少添加一条赛事信息')
          this.currentStep = 1
          this.loading = false
          return
        }

        if (this.formData.progress.length === 0) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.please_add_progress_node || '请至少添加一个进度节点')
          this.currentStep = 2
          this.loading = false
          return
        }

        const startTime = new Date(this.formData.startTime).getTime()
        const endTime = new Date(this.formData.endTime).getTime()
        if (endTime <= startTime) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.end_time_must_after_start || '结束时间必须晚于开始时间')
          this.currentStep = 0
          this.loading = false
          return
        }

        // 验证所有进度节点信息（包括节点名称和节点时间）
        if (!this.validateProgressNodes()) {
          this.currentStep = 2
          this.loading = false
          return
        }

        this.validateSingleNodeTime()

        // 获取当前系统语言
        const currentLanguage = this.getCurrentLanguage()

        const formattedData = {
          id: this.formData.id,
          parentId: this.formData.parentId, // 确保传递主体的parentId
          language: currentLanguage, // 使用当前系统语言
          title: this.formData.title,
          bonus: this.formData.bonus,
          categoryId: this.formData.categoryId,
          zoneId: this.formData.zoneId,
          technicalId: this.formData.technicalId,
          parentCompetitionId: this.formData.parentCompetitionId,
          type: this.formData.type,
          teamsUsers: this.formData.teamsUsers,
          startTime: this.formData.startTime ? moment(this.formData.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
          endTime: this.formData.endTime ? moment(this.formData.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
          mark: this.formData.mark,
          organizers: this.formData.organizers,
          progress: (this.formData.progress || []).map(p => ({
            // 编辑现有记录：有id且有parentId时传递，表示编辑现有记录
            // 新增记录：无id或无parentId时不传递，后端会创建新的parentId
            ...(p.id && p.parentId ? {
              id: p.id,
              parentId: p.parentId
            } : {}),
            title: p.title,
            startDate: p.startDate ? moment(p.startDate).format('YYYY-MM-DD') : '',
            language: currentLanguage,
            position: p.position
          })),
          info: (this.formData.info || []).map(i => ({
            // 编辑现有记录：有id且有parentId时传递，表示编辑现有记录
            // 新增记录：无id或无parentId时不传递，后端会创建新的parentId
            ...(i.id && i.parentId ? {
              id: i.id,
              parentId: i.parentId
            } : {}),
            title: i.title,
            content: i.content,
            images: i.images,
            language: currentLanguage,
            position: i.position,
            infoType: i.infoType
          })),
          name: this.formData.name,
          phone: this.formData.phone,
          unitName: this.formData.unitName,
          titleEn: this.formData.titleEn,
          coBuildUnitNames: JSON.stringify(this.formData.coBuildUnitNames)
        }

        // 处理Logo列表
        if (this.formData.organizersLogo) {
          if (this.formData.organizersLogo.includes(this.STATIC_BASE_URL)) {
            const paths = this.formData.organizersLogo.split(',').map(path => {
              if (path.includes(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX)) {
                return path.replace(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX, '')
              }
              return path
            })
            formattedData.organizersLogo = paths.join(',')
          } else {
            formattedData.organizersLogo = this.formData.organizersLogo
          }
        } else if (this.formData.logoList && this.formData.logoList.length > 0) {
          const paths = this.formData.logoList.map(url => {
            if (url.includes(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX)) {
              return url.replace(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX, '')
            }
            return url
          })
          formattedData.organizersLogo = paths.join(',')
        }

        // 图片处理
        if (this.formData.imagePath) {
          if (this.formData.imagePath.includes(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX)) {
            formattedData.image = this.formData.imagePath.replace(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX, '')
          } else {
            formattedData.image = this.formData.imagePath
          }
        } else if (this.formData.image) {
          if (this.formData.image.includes(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX)) {
            formattedData.image = this.formData.image.replace(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX, '')
          } else if (this.formData.image.includes('/upload/')) {
            formattedData.image = this.formData.image.split('/upload/')[1]
          } else {
            formattedData.image = this.formData.image
          }
        }

        // 调试日志：显示提交的progress和info数据结构
        console.log('提交数据概览:', {
          title: formattedData.title,
          language: formattedData.language,
          isEdit: !!formattedData.id,
          progressCount: formattedData.progress?.length || 0,
          infoCount: formattedData.info?.length || 0
        })

        console.log('Progress数据详情:', formattedData.progress?.map(p => ({
          title: p.title,
          hasId: !!p.id,
          hasParentId: !!p.parentId,
          isExisting: !!(p.id && p.parentId)
        })))

        console.log('Info数据详情:', formattedData.info?.map(i => ({
          title: i.title,
          hasId: !!i.id,
          hasParentId: !!i.parentId,
          isExisting: !!(i.id && i.parentId)
        })))

        console.log('完整提交数据:', formattedData)
        this.$emit('submit', [formattedData])
        this.hasUserModifications = false // 提交后重置修改标记

        // 注意：不在这里重置loading状态，让父组件在真正提交完成后来控制
      } catch (error) {
        console.error('Submit error:', error)
        this.$message.error(this.globalDataArray.siteTemplateLanguage.submit_error || '提交数据时出错，请检查表单数据')

        // 提交出错后重置loading状态
        this.loading = false
      }
    },

    handleCancel() {
      // 取消时重置loading状态
      this.loading = false
      this.$emit('cancel')
    },

    // 提供给父组件调用的方法，用于重置loading状态
    resetLoading() {
      this.loading = false
    },

    addInfo() {
      if (this.formData.info.length >= 20) {
        this.$message.warning(this.globalDataArray.siteTemplateLanguage.max_info_items || '最多添加20条赛事信息')
        return
      }
      const currentLanguage = this.getCurrentLanguage()
      // 新增info项：不设置id和parentId，让后端创建
      this.formData.info.push({
        title: '',
        infoType: 'introduction',
        content: '',
        images: '',
        language: currentLanguage,
        position: this.formData.info.length + 1
        // 注意：新增项目不设置parentId，让后端根据多语言逻辑处理
      })
      this.hasUserModifications = true // 标记用户进行了修改
    },

    removeInfo(index) {
      this.formData.info.splice(index, 1)
      this.hasUserModifications = true // 标记用户进行了修改
    },

    // 选择时间后实时校验
    handleProgressDateChange(date, index) {
      // 注释掉所有时间范围判断逻辑，只保留基本赋值
      const progressList = [...this.formData.progress]
      // const changedProgress = progressList[index]

      // const startTime = this.formData.startTime ? moment(this.formData.startTime).valueOf() : null
      // const endTime = this.formData.endTime ? moment(this.formData.endTime).valueOf() : null

      const selectedDate = date ? moment(date).valueOf() : null

      // // 检查是否超出总时间范围
      // if (startTime && endTime && selectedDate) {
      //   if (selectedDate < startTime || selectedDate > endTime) {
      //     this.$message.error('节点时间必须在赛事开始时间和结束时间之间')
      //     progressList[index].startDate = null
      //     this.formData.progress = progressList
      //     return
      //   }
      // }

      // 检查是否早于已有节点时间
      const otherDates = progressList
        .filter((_, i) => i !== index)
        .map(p => p.startDate)
        .filter(d => d)
        .map(d => moment(d).valueOf())

      if (otherDates.length > 0 && selectedDate) {
        const latestExisting = Math.max(...otherDates)
        if (selectedDate < latestExisting) {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.add_new_node || '新增节点时间不能早于已有节点的最晚时间')
          progressList[index].startDate = null
          this.formData.progress = progressList
        }
      }
    },

    addProgress() {
      if (this.formData.progress.length >= 20) {
        this.$message.warning(this.globalDataArray.siteTemplateLanguage.max_progress_nodes || '最多添加20个进度节点')
        return
      }
      const currentLanguage = this.getCurrentLanguage()

      // 注释掉所有时间范围判断逻辑
      // // 获取当前表单中的 startTime 和 endTime
      // const startTime = this.formData.startTime ? moment(this.formData.startTime).valueOf() : null
      // const endTime = this.formData.endTime ? moment(this.formData.endTime).valueOf() : null

      // // 获取已有节点的最大时间
      let maxExistingTime = null
      if (this.formData.progress && this.formData.progress.length > 0) {
        const existingDates = this.formData.progress
          .map(p => p.startDate)
          .filter(d => d)
          .map(d => moment(d).valueOf())

        maxExistingTime = Math.max(...existingDates)
      }

      // // 构造新节点的默认时间（可以为空）
      const newStartDate = null

      // // 如果有开始时间和结束时间才进行校验
      // if (startTime && endTime) {
      //   // 检查是否超出总时间范围
      //   if (newStartDate && (moment(newStartDate).isBefore(startTime) || moment(newStartDate).isAfter(endTime))) {
      //     this.$message.error('节点时间必须在赛事开始时间和结束时间之间')
      //     return
      //   }
      // }

      // // 检查是否早于已有节点时间
      if (maxExistingTime !== -Infinity && newStartDate && moment(newStartDate).isBefore(moment(maxExistingTime))) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.add_new_node || '新增节点时间不能早于已有节点的最晚时间')
        return
      }

      // 添加新节点 - 新增progress项：不设置id和parentId，让后端创建
      this.formData.progress.push({
        title: '',
        startDate: null,
        language: currentLanguage,
        position: this.formData.progress.length + 1
        // 注意：新增项目不设置id和parentId，让后端根据多语言逻辑处理
      })
      this.hasUserModifications = true // 标记用户进行了修改
    },

    removeProgress(index) {
      this.formData.progress.splice(index, 1)
      this.hasUserModifications = true // 标记用户进行了修改
    },

    handleEditorChange(value, index) {
      this.formData.info[index].content = value
    },

    removeInfoImage(index) {
      if (this.formData.info && this.formData.info[index]) {
        this.formData.info[index].images = ''
        this.$set(this.formData.info, index, { ...this.formData.info[index], images: '' })
      }
    },

    beforeLogoUpload(file) {
      // 验证文件类型
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.only_image_files || '只能上传图片文件!')
        return false
      }

      // 验证文件大小
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.image_size_limit || '图片必须小于2MB!')
        return false
      }

      // 检查上传数量限制
      if (this.getLogoFileCount() >= 4) {
        this.$message.error('最多只能上传4张Logo图片')
        return false
      }

      return true // 允许上传
    },

    handleLogoChange(info) {
      let fileList = [...info.fileList]

      // 为每个文件生成预览URL（即使是正在上传的文件）
      fileList = fileList.map(file => {
        if (file.originFileObj && !file.url && !file.preview) {
          file.preview = URL.createObjectURL(file.originFileObj)
        }
        return file
      })

      // 这里加一个限制：最多保留 4 个有效文件
      const maxCount = 4
      if (fileList.length > maxCount) {
        this.$message.warning('最多只能上传4张Logo图片')
        fileList = fileList.slice(0, maxCount)
      }

      // 更新状态
      this.formData.logoFileList = fileList

      // 过滤掉被用户取消上传或失败的文件（非 'done' 和非 'uploading' 的文件）
      fileList = fileList.filter(file =>
        file.status === 'done' || file.status === 'uploading'
      )

      this.formData.logoFileList = fileList

      // 如果有文件上传成功，更新organizersLogo字段
      const hasSuccessFile = fileList.some(file => file.status === 'done')
      if (hasSuccessFile) {
        this.updateOrganizersLogo()
      }

      // 处理上传成功消息
      // if (info.file.status === 'done') {
      //   this.$message.success(`${info.file.name} ${this.globalDataArray.siteTemplateLanguage.file_success || '文件上传成功'}`)
      // } else if (info.file.status === 'error') {
      //   this.$message.error(`${info.file.name} ${this.globalDataArray.siteTemplateLanguage.file_fail || '文件上传失败'}`)
      // }
    },

    handleLogoRemove(file) {
      // 清理预览URL
      if (file.preview && file.preview.startsWith('blob:')) {
        URL.revokeObjectURL(file.preview)
      }

      // 延迟更新organizersLogo字段，等待fileList更新
      this.$nextTick(() => {
        this.updateOrganizersLogo()
      })

      return true
    },

    handleLogoPreview(file) {
      // 使用标准的预览回调
      const previewUrl = file.url || file.preview || file.thumbUrl
      if (previewUrl) {
        this.previewImage(previewUrl)
      }
    },

    // Logo上传方法
    uploadLogo(options) {
      const { file, onSuccess, onError, onProgress } = options

      const formData = new FormData()
      formData.append('file', file)
      formData.append('biz', 'organizer_logo')

      uploadFile(formData)
        .then(res => {
          if (res && res.success === true) {
            let logoPath = ''

            // 优先从message字段获取路径，再尝试result字段
            if (res.message && typeof res.message === 'string') {
              logoPath = res.message.trim()
            } else if (res.result && typeof res.result === 'string') {
              logoPath = res.result.trim()
            }

            if (logoPath) {
              const url = logoPath.includes(this.STATIC_BASE_URL) ? logoPath : this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX + logoPath

              console.log('Logo上传成功，路径:', logoPath, '显示URL:', url)

              // 更新organizersLogo字段
              this.updateOrganizersLogo()

              onSuccess(res, file)
            } else {
              onError(new Error('上传响应中未找到文件路径'))
            }
          } else {
            onError(new Error(res.message || 'Logo上传失败'))
          }
        })
        .catch(error => {
          console.error('Logo上传失败:', error)
          onError(error)
        })
    },

    // 图片预览方法
    previewImage(url) {
      console.log('预览图片被调用，URL:', url)
      if (!url) {
        console.error('预览图片URL为空')
        this.$message.error('图片URL无效')
        return
      }
      this.previewImageUrl = url
      this.previewVisible = true
      console.log('预览状态设置完成:', {
        previewVisible: this.previewVisible,
        previewImageUrl: this.previewImageUrl
      })
    },

    previewFile(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(file.originFileObj || file)
      })
    },

    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen
      this.$emit('fullscreen-change', this.isFullscreen)
      window.dispatchEvent(new Event('resize'))
    },

    handleFullscreenChange() {
      this.isFullscreen = !!(document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement)
    },

    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.only_image_files || '只能上传图片文件!')
        return false
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error(this.globalDataArray.siteTemplateLanguage.image_size_limit || '图片必须小于2MB!')
        return false
      }

      return true // 允许上传
    },

    handleImageChange(info) {
      // 更新fileList，支持预览
      let fileList = [...info.fileList]

      // 为每个文件生成预览URL（即使是正在上传的文件）
      fileList = fileList.map(file => {
        if (file.originFileObj && !file.url && !file.preview) {
          file.preview = URL.createObjectURL(file.originFileObj)
        }
        return file
      })

      // 过滤掉被用户取消上传或失败的文件（非 'done' 和非 'uploading' 的文件）
      fileList = fileList.filter(file => file.status === 'done' || file.status === 'uploading')

      this.formData.imageFileList = fileList

      // 处理上传成功消息
      if (info.file.status === 'done') {
        // this.$message.success(`${info.file.name} ${this.globalDataArray.siteTemplateLanguage.file_success || '文件上传成功'}`)
        // 上传成功后清除封面图错误提示
        this.validateCoverImage()
      } else if (info.file.status === 'error') {
        // this.$message.error(`${info.file.name} ${this.globalDataArray.siteTemplateLanguage.file_fail || '文件上传失败'}`)
      }
    },

    handleImageRemove(file) {
      // 清理预览URL
      if (file.preview && file.preview.startsWith('blob:')) {
        URL.revokeObjectURL(file.preview)
      }
      return true
    },

    handleImagePreview(file) {
      // 使用标准的预览回调
      const previewUrl = file.url || file.preview || file.thumbUrl
      if (previewUrl) {
        this.previewImage(previewUrl)
      }
    },

    // 封面图上传方法
    uploadImage(options) {
      const { file, onSuccess, onError, onProgress } = options

      const formData = new FormData()
      formData.append('file', file)
      formData.append('biz', 'competition_cover')

      uploadFile(formData)
        .then(res => {
          if (res && res.success === true) {
            let imagePath = ''

            if (res.message && typeof res.message === 'string' && res.message.includes('/')) {
              imagePath = res.message
            } else if (res.result && typeof res.result === 'string') {
              imagePath = res.result
            }

            if (imagePath) {
              // 保存原始路径用于表单提交
              if (imagePath.includes(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX)) {
                this.formData.imagePath = imagePath.replace(this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX, '')
              } else {
                this.formData.imagePath = imagePath
              }

              // 构建完整URL
              const url = imagePath.startsWith('http') ? imagePath
                : imagePath.includes(this.STATIC_BASE_URL) ? imagePath
                  : this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX + imagePath

              // 设置image字段供其他逻辑使用
              this.formData.image = url

              onSuccess(res, file)
            } else {
              onError(new Error('未能获取图片路径，请重试'))
            }
          } else {
            onError(new Error(res.message || '封面图上传失败'))
          }
        })
        .catch(error => {
          console.error('封面图上传失败:', error)
          onError(error)
        })
    },

    setEditData(editData) {
      if (!editData) return
      this.processFormData(editData)
      // 回显 coBuildUnitNames
      if (typeof this.formData.coBuildUnitNames === 'string') {
        try {
          this.formData.coBuildUnitNames = JSON.parse(this.formData.coBuildUnitNames)
        } catch {
          this.formData.coBuildUnitNames = []
        }
      }
      if (!Array.isArray(this.formData.coBuildUnitNames)) {
        this.formData.coBuildUnitNames = []
      }
      this.hasUserModifications = false // 重置修改标记，允许数据设置
    },

    processFormData(data) {
      // 处理共建方Logo回显
      if (data.organizersLogo) {
        const logoUrls = data.organizersLogo.split(',').filter(url => url)
        data.logoFileList = logoUrls.map((url, index) => {
          const fullUrl = url.startsWith('http') ? url
            : url.includes(this.STATIC_BASE_URL) ? url
              : this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX + url

          return {
            uid: `logo-${index}`,
            name: `logo-${index}.jpg`,
            status: 'done',
            url: fullUrl,
            thumbUrl: fullUrl
          }
        })
        console.log('编辑模式：Logo文件列表', data.logoFileList)
      } else {
        data.logoFileList = []
      }

      // 处理封面图回显
      if (data.image) {
        data.imagePath = data.image
        const fullUrl = data.image.startsWith('http') ? data.image
          : data.image.includes(this.STATIC_BASE_URL) ? data.image
            : this.STATIC_BASE_URL + this.STATIC_FILE_SUFFIX + data.image

        data.imageFileList = [{
          uid: 'cover-image',
          name: 'cover-image.jpg',
          status: 'done',
          url: fullUrl,
          thumbUrl: fullUrl
        }]

        // 保持image字段供其他逻辑使用
        data.image = fullUrl
        console.log('编辑模式：封面图文件列表', data.imageFileList)
      } else {
        data.imageFileList = []
      }

      if (data.startTime) {
        data.startTime = moment(data.startTime)
      }
      if (data.endTime) {
        data.endTime = moment(data.endTime)
      }

      if (data.progress) {
        data.progress = data.progress.map(p => ({
          ...p,
          startDate: p.startDate ? moment(p.startDate) : null
          // 保留所有字段包括id和parentId，让前端在提交时根据这些字段判断是编辑还是新增
        }))
      }

      if (data.info) {
        data.info = data.info.map(i => ({
          ...i
          // 保留所有字段包括id和parentId，让前端在提交时根据这些字段判断是编辑还是新增
        }))
      }

      // 确保使用当前系统语言
      data.language = this.getCurrentLanguage()
      this.formData = { ...this.formData, ...data }

      console.log('编辑模式：表单数据处理完成', {
        logoCount: data.logoFileList.length,
        imageCount: data.imageFileList.length
      })
    },

    updateLocale() {
      const currentLang = this.getCurrentLanguage()
      console.log('更新locale，当前语言:', currentLang)

      // 语言映射表
      const localeMap = {
        'zh_CN': zhCN,
        'zh-CN': zhCN,
        'zh': zhCN,
        'en_US': enUS,
        'en-US': enUS,
        'en': enUS,
        'ja_JP': jaJP,
        'ja-JP': jaJP,
        'ja': jaJP,
        'ko_KR': koKR,
        'ko-KR': koKR,
        'ko': koKR,
        'fr_FR': frFR,
        'fr-FR': frFR,
        'fr': frFR,
        'de_DE': deDE,
        'de-DE': deDE,
        'de': deDE,
        'es_ES': esES,
        'es-ES': esES,
        'es': esES,
        'ru_RU': ruRU,
        'ru-RU': ruRU,
        'ru': ruRU,
        'pt_BR': ptBR,
        'pt-BR': ptBR,
        'pt': ptBR,
        'it_IT': itIT,
        'it-IT': itIT,
        'it': itIT
      }

      // moment.js语言映射
      const momentLocaleMap = {
        'zh_CN': 'zh-cn',
        'zh-CN': 'zh-cn',
        'zh': 'zh-cn',
        'en_US': 'en',
        'en-US': 'en',
        'en': 'en',
        'ja_JP': 'ja',
        'ja-JP': 'ja',
        'ja': 'ja',
        'ko_KR': 'ko',
        'ko-KR': 'ko',
        'ko': 'ko',
        'fr_FR': 'fr',
        'fr-FR': 'fr',
        'fr': 'fr',
        'de_DE': 'de',
        'de-DE': 'de',
        'de': 'de',
        'es_ES': 'es',
        'es-ES': 'es',
        'es': 'es',
        'ru_RU': 'ru',
        'ru-RU': 'ru',
        'ru': 'ru',
        'pt_BR': 'pt-br',
        'pt-BR': 'pt-br',
        'pt': 'pt-br',
        'it_IT': 'it',
        'it-IT': 'it',
        'it': 'it'
      }

      // 尝试精确匹配
      if (localeMap[currentLang]) {
        this.locale = localeMap[currentLang]
        // 设置moment.js语言
        if (momentLocaleMap[currentLang]) {
          moment.locale(momentLocaleMap[currentLang])
          console.log('设置moment语言:', momentLocaleMap[currentLang])
        }
        console.log('精确匹配locale:', this.locale.locale)
        return
      }

      // 尝试语言前缀匹配
      const langPrefix = currentLang.split('_')[0].split('-')[0]
      if (localeMap[langPrefix]) {
        this.locale = localeMap[langPrefix]
        // 设置moment.js语言
        if (momentLocaleMap[langPrefix]) {
          moment.locale(momentLocaleMap[langPrefix])
          console.log('设置moment语言:', momentLocaleMap[langPrefix])
        }
        console.log('前缀匹配locale:', this.locale.locale)
        return
      }

      // 默认使用中文
      this.locale = zhCN
      moment.locale('zh-cn')
      console.log('使用默认locale:', this.locale.locale)
    },

    updateLocaleForSystemLanguage(newLanguage) {
      console.log(`系统语言变化: ${this.formData.language} -> ${newLanguage}`)

      // 更新表单数据语言
      this.formData.language = newLanguage

      // 更新locale设置
      this.updateLocale()

      // 更新现有info项目的语言
      if (this.formData.info && this.formData.info.length > 0) {
        this.formData.info.forEach(item => {
          item.language = newLanguage
        })
      }

      // 更新现有progress项目的语言
      if (this.formData.progress && this.formData.progress.length > 0) {
        this.formData.progress.forEach(item => {
          item.language = newLanguage
        })
      }

      // 强制重新渲染组件以应用新的locale
      this.$nextTick(() => {
        this.$forceUpdate()
      })

      console.log(`语言已切换到: ${newLanguage}, locale:`, this.locale)
    },

    // 更新organizersLogo字段
    updateOrganizersLogo() {
      this.$nextTick(() => {
        const paths = this.formData.logoFileList
          .filter(file => file.status === 'done' && file.response)
          .map(file => {
            if (file.response) {
              // 优先从message字段获取路径，再尝试result字段
              if (file.response.message && typeof file.response.message === 'string') {
                return file.response.message.trim()
              } else if (file.response.result && typeof file.response.result === 'string') {
                return file.response.result.trim()
              }
            }
            return null
          })
          .filter(path => path)

        this.formData.organizersLogo = paths.join(',')
        console.log('Updated organizersLogo:', this.formData.organizersLogo)
      })
    },

    // 开始时间
    handleStartTimeChange(date, formItem) {
      // 处理开始时间选择
      if (date && moment.isMoment(date) && date.isValid()) {
        const end = formItem.endTime

        // 如果已经有结束时间，验证开始时间不能晚于结束时间
        if (end && moment.isMoment(end) && end.isValid()) {
          if (date.isSameOrAfter(end, 'minute')) {
            this.$message.error(this.globalDataArray.siteTemplateLanguage.start_end || '开始时间不能晚于或等于结束时间，请重新选择')
            this.$set(formItem, 'startTime', date)
            return
          }
        }

        // 验证通过，设置开始时间
        this.$set(formItem, 'startTime', date)
        this.startTimeError = ''
      } else {
        this.$set(formItem, 'startTime', date)
      }
    },

    // 结束时间
    handleEndTimeChange(date, formItem) {
      // 处理结束时间选择
      if (date && moment.isMoment(date) && date.isValid()) {
        const start = formItem.startTime

        // 如果已经有开始时间，验证结束时间不能早于开始时间
        if (start && moment.isMoment(start) && start.isValid()) {
          if (date.isSameOrBefore(start, 'minute')) {
            this.$message.error(this.globalDataArray.siteTemplateLanguage.start_end || '开始时间不能晚于或等于结束时间，请重新选择')
            this.$set(formItem, 'endTime', undefined)
            return
          }
        }

        // 验证通过，设置结束时间
        this.$set(formItem, 'endTime', date)
        this.endTimeError = ''
      } else {
        this.$set(formItem, 'endTime', undefined)
      }
    },

    // 赛事标题验证
    validateTitle() {
      const value = this.formData.title
      if (!value || value.trim() === '') {
        this.titleError = this.globalDataArray.siteTemplateLanguage.please_enter_competition_name || '请输入赛事名称'
        return false
      }
      // 只有标题不为空时才清除错误（异步验证可能会设置其他错误）
      if (!this.titleError.includes('已存在') && !this.titleError.includes('错误')) {
        this.titleError = ''
      }
      return true
    },

    async handleTitleBlur(titleValue) {
      // 增强参数验证：检查参数是否有效
      if (!titleValue || titleValue.trim() === '' ||
          titleValue === 'undefined' || titleValue === 'null') {
        this.titleError = ''
        return
      }

      // 先进行基础验证
      if (!this.validateTitle()) {
        return
      }

      // 防抖处理，避免频繁调用
      if (this.titleValidateTimer) {
        clearTimeout(this.titleValidateTimer)
      }

      this.titleValidateTimer = setTimeout(async () => {
        try {
          // 确保参数清洁有效
          const cleanTitle = titleValue.trim()
          if (!cleanTitle || cleanTitle.length === 0) {
            this.titleError = ''
            return
          }

          // 构建验证参数 - 使用对象形式而不是字符串拼接
          const params = {
            title: cleanTitle
          }

          // 如果是编辑模式，传递编辑相关参数
          if (this.formData.id) {
            params.competitionId = this.formData.id
          }
          if (this.formData.parentId) {
            params.parentId = this.formData.parentId
          }

          console.log('标题验证参数:', params)
          const res = await verifyTitle(params)
          console.log('标题验证响应:', res)

          if (!res.success) {
            this.titleError = res.message || '该赛事名称已存在，请更换'
          } else {
            // 验证成功，清除错误提示
            this.titleError = ''
          }
        } catch (error) {
          console.error('标题验证错误:', error)
          this.titleError = '检查赛事名称时发生错误，请稍后再试'
        }
      }, 500) // 500ms防抖延迟
    },
    clearNodeTimeError(index) {
      // 只清除时间错误，不影响标题错误
      this.$set(this.formData.progress[index], 'startDateError', '')
    },

    // 验证单个节点的标题
    validateNodeTitle(index) {
      const progress = this.formData.progress[index]
      if (!progress || !progress.title || progress.title.trim() === '') {
        this.$set(this.formData.progress[index], 'titleNodeError', this.globalDataArray.siteTemplateLanguage.please_enter_node_title || '请输入节点标题')
        return false
      } else {
        this.$set(this.formData.progress[index], 'titleNodeError', '')
        return true
      }
    },

    // 处理节点标题输入
    handleNodeTitleInput(index) {
      // 输入时实时清除错误提示
      const progress = this.formData.progress[index]
      if (progress && progress.title && progress.title.trim() !== '') {
        this.$set(this.formData.progress[index], 'titleNodeError', '')
      }
    },

    // 清除节点标题错误
    clearNodeTitleError(index) {
      this.$set(this.formData.progress[index], 'titleNodeError', '')
    },

    // 验证单个节点的时间
    validateNodeTime(index) {
      const progress = this.formData.progress[index]
      if (!progress || !progress.startDate) {
        this.$set(this.formData.progress[index], 'startDateError', this.globalDataArray.siteTemplateLanguage.please_set_node_time || '请设置节点时间')
        return false
      } else {
        this.$set(this.formData.progress[index], 'startDateError', '')
        return true
      }
    },
    validateTitleEn() {
      if (!this.formData.titleEn || !this.formData.titleEn.trim()) {
        this.titleEnError = '请输入赛事英文名称'
        return false
      }
      this.titleEnError = ''
      return true
    },
    validateCoBuildUnitNames() {
      if (!Array.isArray(this.formData.coBuildUnitNames) || this.formData.coBuildUnitNames.length === 0) {
        this.coBuildUnitNamesError = '请至少添加一组共建单位中英文名称'
        return false
      }
      for (const unit of this.formData.coBuildUnitNames) {
        if (!unit.name_zh || !unit.name_en) {
          this.coBuildUnitNamesError = '每组共建单位名称的中英文都不能为空'
          return false
        }
      }
      this.coBuildUnitNamesError = ''
      return true
    },
    addCoBuildUnitName() {
      if (!Array.isArray(this.formData.coBuildUnitNames)) {
        this.$set(this.formData, 'coBuildUnitNames', [])
      }
      const arr = this.formData.coBuildUnitNames.slice()
      arr.push({ id: Date.now() + '-' + Math.random(), name_zh: '', name_en: '' })
      this.$set(this.formData, 'coBuildUnitNames', arr)
    },
    removeCoBuildUnitName(idx) {
      if (Array.isArray(this.formData.coBuildUnitNames)) {
        this.$delete(this.formData.coBuildUnitNames, idx)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.formCon {
  justify-content: center;
  display: flex;
  width: 100%;
}

// Add the override style for form item labels
:deep(.ant-form-vertical .ant-form-item-label),
:deep(.ant-col-24.ant-form-item-label),
:deep(.ant-col-xl-24.ant-form-item-label) {
  padding: 0 !important;

  &::after {
    content: '：';
    margin: 0 4px 0 2px;
  }
}

.pagePop {
  width: 100%;
  max-width: 1200px; // 添加最大宽度限制

  &.is-fullscreen {
    // 使用固定定位替代原生全屏
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important; // 改为100%
    max-width: none !important; // 移除最大宽度限制
    height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    z-index: 10001 !important;
    overflow: auto !important;

    // 调整内容容器样式
    .w.pad60 {
      height: 100%;
      display: flex;
      flex-direction: column;
      max-width: none !important; // 移除内容区域的最大宽度限制
      width: 100% !important; // 确保内容区域占满宽度

      // 让内容区域自动填充剩余空间
      .cont {
        flex: 1;
        overflow: auto;
        position: relative;
        width: 100% !important; // 确保内容区域占满宽度
        max-height: none !important; // 在全屏模式下移除高度限制
        // 在全屏模式下，让内容区域占据除标题栏和按钮栏外的所有空间
        height: calc(100vh - 160px); // 减去标题栏和按钮栏的高度
      }
    }
  }

  .tit {
    display: flex;
    justify-content: space-between;
    position: relative;

    .tit-icons {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .icon-btn {
      font-size: 16px;
      cursor: pointer;
      padding: 8px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  // 修复日期选择器样式
  :deep(.ant-calendar-picker) {
    // 设置日期选择器容器为相对定位，让弹出层基于它定位
    position: relative;

    .ant-calendar-picker-input {
      width: 100%;
      // 确保输入框可以接收点击事件
      z-index: 1;
    }
  }

  // 优化下拉菜单定位
  :deep(.ant-select) {
    // 设置选择器容器为相对定位
    position: relative;
  }

  // 确保下拉框和日期选择器弹出层在合适的层级显示
  :deep(.ant-select-dropdown),
  :deep(.ant-calendar-picker-container),
  :deep(.ant-tooltip) {
    z-index: 1050 !important;
  }

  // 针对全屏模式提供更高的层级
  &.is-fullscreen {
    :deep(.ant-select-dropdown),
    :deep(.ant-calendar-picker-container),
    :deep(.ant-tooltip) {
      z-index: 10002 !important;
    }
  }

  // 优化表单布局
  .stform {
    padding: 0;
    background: transparent;

    .item {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
      align-items: flex-start; // 顶部对齐，避免错误提示影响布局

      // 表单字段容器
      .form-field {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0; // 允许收缩

        // 在小屏幕下占满整行
        @media screen and (max-width: 768px) {
          min-width: 100%;
        }
      }

      .ant-form-item {
        margin-bottom: 4px; // 减少底部边距，为错误提示留空间
        width: 100%;

        .ant-form-item-label {
          padding-bottom: 6px;
          line-height: 1.5715;

          > label {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 400;
            height: auto;
          }
        }

        .ant-form-item-control {
          line-height: 1.5715;
        }

        // 优化输入框样式
        .ant-input,
        .ant-select-selector {
          border-radius: 6px;
          padding: 8px 12px;
          font-size: 14px;
          transition: border-color 0.3s;

          &:focus,
          &:hover {
            border-color: #40a9ff;
          }
        }

        .ant-select-selector {
          padding: 4px 12px;
          min-height: 36px;
        }

        // 日期选择器样式
        .ant-calendar-picker {
          width: 100%;

          .ant-calendar-picker-input {
            border-radius: 6px;
            border: 1px solid #d9d9d9;
            padding: 8px 12px;
            font-size: 14px;
            height: 36px;
            transition: border-color 0.3s;

            &:focus,
            &:hover {
              border-color: #40a9ff;
            }
          }
        }
      }

      // 单字段项目样式
      &.single-field {
        .form-field {
          width: 100%;
          max-width: 100%;
        }
      }

      // 全宽度项目样式
      &.full-width {
        .form-field {
          width: 100%;
          max-width: 100%;
        }
      }

      // 在小屏幕下的布局调整
      @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 16px;

        .form-field {
          width: 100%;
        }
      }
    }

    // 错误提示样式
    .error-message {
      color: #ff4d4f;
      font-size: 12px;
      line-height: 1.4;
      margin-top: 2px;
      margin-bottom: 8px;
      padding-left: 0;
      display: block;
      word-break: break-word;
      min-height: 14px; // 减少最小高度
    }

    // 信息表单样式
    .info-form {
      .info-item {
        border: 1px solid #e8e8e8;
        border-radius: 6px;
        padding: 24px;
        margin-bottom: 24px;
        background: #fafafa;

        .info-header {
          margin-bottom: 16px;

          // 确保删除按钮与表单项对齐
          .ant-form-item {
            flex: 1;
            min-width: 300px;
          }

          .ant-btn {
            flex-shrink: 0;
            align-self: flex-start;
          }

          @media screen and (max-width: 768px) {
            flex-direction: column;
            gap: 16px;
            align-items: stretch;

            .ant-btn {
              align-self: stretch;
            }
          }
        }

        .image-preview {
          margin-bottom: 16px;

          img {
            max-width: 200px;
            max-height: 200px;
            object-fit: contain;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
          }
        }
      }
    }

    // 进度表单样式
    .progress-form {
      // 移除特殊样式，使用通用的 .item 样式
    }
  }

  // Logo上传区域样式
  .logo-upload-container {
    width: 100%;
    margin: 20px 0; // 添加上下边距
    padding-bottom: 8px;

    // 样式化上传组件，保持与已上传图片尺寸一致
    :deep(.ant-upload-list-picture-card .ant-upload-list-item),
    :deep(.ant-upload.ant-upload-select-picture-card) {
      width: 104px;
      height: 104px;
      margin: 0;
      flex-shrink: 0;
      object-fit: contain !important;
    }

    :deep(.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img) {
      object-fit: contain !important;
      background-color: #f0f0f0;
    }

    // 确保上传按钮容器不被挤压
    :deep(.ant-upload-picture-card-wrapper) {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: flex-start;
      margin: 8px 0;
    }
  }

  //logo和封面上传框居中
  :deep(.ant-upload-picture-card-wrapper) {
    display: flex;
    align-items: center;
  }

  .placeholder {
    display: flex;
    justify-content: center;
    text-align: center;
  }

  :deep(.ant-upload-list-picture-card-container) {
    float: left;
    width: 104px;
    height: 104px;
    margin: 0 8px 0 0;
  }
}
.text-tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

/* 兼容移动端 */
@media only screen and (max-width: 768px) {
  .formCon {
    .pagePop {
      top: 20px;
      /* height: 94%; */
      width: 90%;
      /* overflow-y: scroll; */
    }
  }
}

/* 按钮状态样式 */
.btnBox {
  .btn {
    transition: all 0.3s ease;

    &[disabled="disabled"],
    &.loading {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        opacity: 0.6;
      }
    }

    &.loading {
      position: relative;
    }
  }
}

/* 改善日期选择器定位的额外样式 */
:deep(.ant-calendar-picker-container) {
  // 使用绝对定位而不是固定定位，确保跟随容器滚动
  position: absolute !important;
}

/* 确保日期选择器在滚动容器内正确显示 */
.formC {
  // 为滚动容器建立层叠上下文
  // position: relative;

  // 确保内容区域可以滚动
  .cont {
    position: relative;
    overflow: auto; // 使用滚动条处理超出内容
    max-height: calc(100vh - 200px); // 限制最大高度，为按钮区域预留空间
  }
}

/* 防止日期选择器被遮挡 */
:deep(.ant-calendar-picker-container .ant-calendar) {
  // 使用合适的阴影突出显示
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #d9d9d9;
}

/* 优化全屏模式下的日期选择器 */
.is-fullscreen {
  :deep(.ant-calendar-picker-container) {
    // 在全屏模式下确保定位正确
    position: absolute !important;
    // 移除可能导致定位问题的transform
    transform: none !important;
  }
}

.co-build-unit-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px 16px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafbfc;
  transition: border-color 0.2s;
}
.co-build-unit-group:hover {
  border-color: #1890ff;
  background: #f0f7ff;
}
</style>
